(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iltc-tab-blog"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.blog-tabs__btn');
    if (!btn) return;
    var wrap = btn.closest('[data-blog-tabs]');
    if (!wrap) return;
    wrap.querySelectorAll('.blog-tabs__btn').forEach(function (b) {
      b.classList.remove('is-active');
      b.setAttribute('aria-selected', 'false');
    });
    wrap.querySelectorAll('.blog-tabs__panel').forEach(function (p) {
      p.classList.remove('is-active');
    });
    btn.classList.add('is-active');
    btn.setAttribute('aria-selected', 'true');
    var panel = wrap.querySelector('#' + btn.dataset.tabTarget);
    if (panel) panel.classList.add('is-active');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-bottom-nav"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mobile-bottom-nav-drawer')) {
    class MobileBottomNavDrawer extends HTMLElement {
      connectedCallback() {
        this.drawer = this.querySelector('.mobile-bottom-nav__drawer');
        this.overlay = this.querySelector('[data-drawer-overlay]');
        this.openBtn = this.querySelector('[data-open-brands-drawer]');
        this.closeBtn = this.querySelector('[data-drawer-close]');
        this.cartBubble = this.querySelector('[data-cart-count-bubble]');

        this.openBtn?.addEventListener('click', () => this.open());
        this.closeBtn?.addEventListener('click', () => this.close());
        this.overlay?.addEventListener('click', () => this.close());
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') this.close();
        });

        // Keep the cart bubble in sync if other parts of the theme
        // (or the bundle "Add to cart" buttons) dispatch cart:update.
        document.addEventListener('cart:update', (e) => {
          const cart = e?.detail?.cart;
          if (!cart || !this.cartBubble) return;
          this.cartBubble.textContent = cart.item_count;
          this.cartBubble.hidden = cart.item_count === 0;
        });
      }

      open() {
        this.drawer.classList.add('is-open');
        this.classList.add('drawer-open');
        document.body.style.overflow = 'hidden';
      }

      close() {
        this.drawer.classList.remove('is-open');
        this.classList.remove('drawer-open');
        document.body.style.overflow = '';
      }
    }

    customElements.define('mobile-bottom-nav-drawer', MobileBottomNavDrawer);
  }

  } catch(e) { console.error(e); }
})();
})();
